<ng-template #cpuInput>

  <table aria-label="Elements" class="full-width-table" mat-table matSort>

    @for (desc of columnDescriptions; track $index) {
      <ng-container [matColumnDef]="desc.id">
        @if (desc.sortable) {
          <th *matHeaderCellDef [attr.data-type]="desc.type" mat-header-cell mat-sort-header><span [innerHTML]="desc.label"></span></th>
        } @if (!desc.sortable) {
        <th *matHeaderCellDef [attr.data-type]="desc.type" mat-header-cell><span [innerHTML]="desc.label"></span></th>
      }
        <td *matCellDef="let cell" [attr.aria-label]="getCellLabel(desc.id)" [attr.data-label]="desc.label" [attr.data-type]="desc.type" [ngClass]="getCellCss(desc.id, cell)" mat-cell>
          <label [innerHTML]="desc.label" [ngClass]="'label--td'"></label>
          @switch (desc.type) {
            @case ('icon') {
              <mat-icon [ngClass]="getCellCss(desc.id, cell)">{{ getCellData(desc.id, cell) }}</mat-icon>
            }
            <!-- Achtung! keinen Zeilenumbruch nach > oder vor < bei Zellenwert, sonst wird da nbsp eingefügt, der das Layout verhunzt -->
            @default {
              {{ getCellData(desc.id, cell) }}
            }
          }
        </td>
      </ng-container>
    }

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>

    <!--     <ng-container *ngFor="let desc of columnDescription; let idx = index; let even = even; let odd = odd; let first = first; let last = last; let trackBy = trackItem" matColumnDef="id">
    kann auch für Zeilen angewandt werden, mit

    trackItem(index, item) {
    return item? item.id : undefined;
  }

  wobei trackBy optional ist, nur wenn man Tracking der Zeilen optimieren möchte.
  -->
    <!--
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"
      (click)="highlight(row)"
      (mouseover)="row.hovered = true"
    (mouseout)="row.hovered = false"></tr>
    -->
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>

  </table>

  @if (!noPaginator) {
    <mat-paginator #paginator
                   [pageIndex]="pageIndex()"
                   [pageSizeOptions]="pageSizeOptions()"
                   [pageSize]="pageSize()">
    </mat-paginator>
  }

</ng-template>

<app-base [childContext]="ctx" [componentsTemplate]="cpuInput"></app-base>
